'use client';

import React from 'react';
import { getWhatsAppUrl } from '@/lib/utils';

export function WhatsAppButton(): React.JSX.Element {
  return (
    <aside aria-label="Contacto directo" className="fixed bottom-6 right-6 z-50">
      <a
        href={getWhatsAppUrl()}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Contactar por WhatsApp"
        className="flex items-center space-x-2 px-4 py-3 rounded-full bg-emerald-500 hover:bg-emerald-400 text-black font-bold text-xs shadow-[0_0_20px_rgba(16,185,129,0.5)] transition-all duration-300 hover:scale-105 active:scale-95 group"
      >
        <span className="text-base">💬</span>
        <span className="tracking-wide">Consultar por WhatsApp</span>
      </a>
    </aside>
  );
}
